import { NormalizedCacheObject } from 'apollo-boost';

import {
    addMinusKeywordsPacksMutation,
    deleteMinusKeywordsPacksMutation,
    updateAdGroupMinusKeywordsMutation,
    updateMinusKeywordsPacksMutation
} from '../../graphql/mutations/grid/minus-phrase';
import { ValidationResultItem } from '../../typings/common';
import {
    addMinusKeywordsPacks,
    deleteMinusKeywordsPacks,
    GdAddMinusKeywordsPacksInput,
    GdDeleteMinusKeywordsPacksInput,
    GdUpdateAdGroupMinusKeywordsInput,
    GdUpdateMinusKeywordsPacksInput,
    updateAdGroupMinusKeywords,
    updateMinusKeywordsPacks
} from '../../typings/graphql-grid';
import { DNAApolloClient } from '../DNAApolloClient/DNAApolloClient';

export interface MinusPhraseMutationResultData {
    data:
        | addMinusKeywordsPacks
        | updateMinusKeywordsPacks
        | deleteMinusKeywordsPacks;
    validationResult?: ValidationResultItem[];
}

export interface UpdateAdGroupsMinusPhrasesData {
    data: string[];
}

export class MinusPhraseMutationExecutor {
    constructor(private client: DNAApolloClient<NormalizedCacheObject>) {}

    public async addMinusKeywordsPack(
        input: GdAddMinusKeywordsPacksInput
    ): Promise<MinusPhraseMutationResultData> {
        const result = await this.client.mutate<addMinusKeywordsPacks>({
            mutation: addMinusKeywordsPacksMutation,
            variables: {
                input
            }
        });

        const data = result.data as addMinusKeywordsPacks;
        let validationResult;

        if (data.addMinusKeywordsPacks.validationResult) {
            validationResult =
                data.addMinusKeywordsPacks.validationResult.errors;
        }

        return {
            data,
            validationResult
        };
    }

    public async updateMinusKeywordsPacks(
        input: GdUpdateMinusKeywordsPacksInput
    ): Promise<MinusPhraseMutationResultData> {
        const result = await this.client.mutate<updateMinusKeywordsPacks>({
            mutation: updateMinusKeywordsPacksMutation,
            variables: {
                input
            }
        });

        const data = result.data as updateMinusKeywordsPacks;
        let validationResult;

        if (data.updateMinusKeywordsPacks.validationResult) {
            validationResult =
                data.updateMinusKeywordsPacks.validationResult.errors;
        }

        return {
            data,
            validationResult
        };
    }

    public async deleteMinusKeywordsPacks(
        input: GdDeleteMinusKeywordsPacksInput
    ): Promise<MinusPhraseMutationResultData> {
        const result = await this.client.mutate<deleteMinusKeywordsPacks>({
            mutation: deleteMinusKeywordsPacksMutation,
            variables: {
                input
            }
        });

        const data = result.data as deleteMinusKeywordsPacks;
        let validationResult;

        if (data.deleteMinusKeywordsPacks.validationResult) {
            validationResult =
                data.deleteMinusKeywordsPacks.validationResult.errors;
        }

        return {
            data: result.data as deleteMinusKeywordsPacks,
            validationResult
        };
    }

    public async updateAdGroupToMinusKeywordsPacks(
        input: GdUpdateAdGroupMinusKeywordsInput
    ): Promise<UpdateAdGroupsMinusPhrasesData> {
        const result = await this.client.mutate<updateAdGroupMinusKeywords>({
            mutation: updateAdGroupMinusKeywordsMutation,
            variables: {
                input
            }
        });

        const data = result.data;

        return {
            data: data
                ? data.updateAdGroupMinusKeywords.updatedAdGroupIds.map(String)
                : []
        };
    }
}
